exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-552cd848] .search-input{border-radius:.5rem;border:1px solid #000}[data-v-552cd848] ::placeholder{color:#5e5f5f!important;opacity:1}.clear-icon[data-v-552cd848]{right:40px;top:50%;transform:translateY(-50%)}", ""]);

// exports
